import styled, { css } from "styled-components";

import { colors } from "../../themes";
import { colorFromTheme } from "../../utils/color";

const Badge = styled.span<{
  variant?: "plain" | "contained";
  color?: colors;
}>`
  display: inline-block;
  padding: 0.33rem 0.5rem;
  font-size: 1.1rem;

  ${({ variant = "contained", color }) =>
    variant === "contained" &&
    css`
      border-radius: 0.5rem;
      background-color: ${colorFromTheme(color ?? "surface3")};
      border: 1px solid ${colorFromTheme(color ?? "surface6")};
      color: ${colorFromTheme(color ?? "surface3", "contrastTextColor")};
    `}
`;

export default Badge;
